module.exports = __webpack_public_path__ + "media/images/hero-e47e6e633816ef2c841903bcea28a623.png";